export const MuiDialog = {
  styleOverrides: {
    paper: {
      borderRadius: '7px',
      '@media (max-width: 600px)': {
        width: '90%',
        margin: '32px 20px'
      }
    }
  }
}
